import React from 'react'

function DualSpinner() {
  return (
    <span>
      <style jsx>
        {`
          .ylurnDualSpinner {
            vertical-align: middle;
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-left: 5px;
            vertical-align: middle;
          }

          .ylurnDualSpinner:after {
            content: ' ';
            display: block;
            width: 20px;
            height: 20px;
            margin: 1px;
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 0.26);
            border-color: rgba(0, 0, 0, 0.26) transparent rgba(0, 0, 0, 0.26)
              transparent;
            animation: lds-dual-ring 1.2s linear infinite;
          }

          @keyframes lds-dual-ring {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      <span className="ylurnDualSpinner" />
    </span>
  )
}

export default DualSpinner
